import {
  Box,
  Center,
  HStack,
  Icon,
  IconButton,
  useBoolean,
} from "@chakra-ui/react";
import BadgeIcon from "components/BadgeIcon";
import BearLevel from "components/BearLevel";
import BoldSpinner from "components/BoldSpinner";
import LevelInfoPopup from "components/LevelInfoPopup";
import useBear from "hooks/useBear";
import { FaInfo } from "react-icons/fa";

const BearLevelContainer = () => {
  const { levelDetails } = useBear();
  const [isInfoPopupOpen, setInfoPopupOpenOpen] = useBoolean();

  return (
    <>
      <HStack w="full" spacing="0">
        <Center
          w="10"
          h="10"
          bg="secondary.500"
          flex="none"
          borderRadius="full"
          mr="2"
          display={{
            base: "none",
            sm: "flex",
          }}
        >
          <Icon as={BadgeIcon} w="6" h="auto" color="dark.600" />
        </Center>

        <Box w="full">
          {levelDetails ? (
            <BearLevel
              level={levelDetails.currentLevel}
              nextLevelHoneyRequirement={levelDetails.nextLevelHoneyRequirement}
              nextLevelProgress={levelDetails.nextLevelProgress}
            />
          ) : (
            <BoldSpinner mx="1.5" mt="1.5" thickness="3px" size="sm" />
          )}
        </Box>

        <IconButton
          aria-label=""
          p={{
            base: "3",
            sm: "3",
          }}
          minW="auto"
          icon={<Icon as={FaInfo} w="4" h="auto" />}
          variant="link"
          onClick={setInfoPopupOpenOpen.toggle}
        />
      </HStack>

      <LevelInfoPopup
        isOpen={isInfoPopupOpen}
        onClose={setInfoPopupOpenOpen.off}
      />
    </>
  );
};

export default BearLevelContainer;
